(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sy-pdp-complete-kit"] && !Shopify.designMode) return;
  try {
    (function(){
  var roots = document.querySelectorAll('[data-sy-kit]');
  if (!roots.length) return;
  console.log('[sy-pdp-complete-kit] init');
  roots.forEach(function(root){
    var boxes = root.querySelectorAll('.sy-kit__cb');
    var btn = root.querySelector('[data-sy-kit-add]');
    var label = root.querySelector('[data-sy-kit-label]');
    var base = label ? label.textContent : 'Add selected to cart';
    function sel(){ return Array.prototype.filter.call(boxes, function(b){ return b.checked && !b.disabled; }); }
    function sync(){ var n = sel().length; btn.disabled = n === 0; if (label) label.textContent = n ? base + ' (' + n + ')' : base; }
    boxes.forEach(function(b){ b.addEventListener('change', sync); });
    btn.addEventListener('click', function(){
      var items = sel().map(function(b){ return { id: Number(b.value), quantity: 1 }; });
      if (!items.length) return;
      btn.disabled = true; if (label) label.textContent = 'Adding…';
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items: items }) })
        .then(function(r){ return r.json(); })
        .then(function(){
          document.documentElement.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {bubbles:true}));
          document.documentElement.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {bubbles:true}));
          boxes.forEach(function(b){ b.checked = false; }); sync();
        })
        .catch(function(){ if (label) label.textContent = 'Could not add, try again'; btn.disabled = false; });
    });
    sync();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sy-pdp-size-hint"] && !Shopify.designMode) return;
  try {
    (function(){
  var roots = document.querySelectorAll('[data-sy-szh]');
  if (!roots.length) return;
  console.log('[sy-pdp-size-hint] init');
  roots.forEach(function(root){
    var btn = root.querySelector('.sy-szh__toggle');
    var panel = root.querySelector('.sy-szh__panel');
    if (btn && panel){
      btn.addEventListener('click', function(){
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    }
    root.querySelectorAll('.sy-szh__scroll').forEach(function(s){
      s.addEventListener('click', function(){
        var sel = s.getAttribute('data-target');
        var target = sel ? document.querySelector(sel) : null;
        if (!target) return;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sy-pdp-watch-video"] && !Shopify.designMode) return;
  try {
    (function(){
  var roots = document.querySelectorAll('[data-sy-watch]');
  if (!roots.length) return;
  console.log('[sy-pdp-watch-video] init');
  roots.forEach(function(root){
    var btn = root.querySelector('[data-sy-watch-open]');
    var dlg = root.querySelector('[data-sy-watch-dialog]');
    var close = root.querySelector('[data-sy-watch-close]');
    var media = document.getElementById('product-media');
    if (media && getComputedStyle(media).position === 'static') media.style.position = 'relative';
    if (media) { btn.classList.add('sy-watch__btn--overlay'); media.appendChild(btn); }
    function vid(){ return dlg.querySelector('video'); }
    btn.addEventListener('click', function(){
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open','');
    });
    function shut(){ var v=vid(); if(v){v.pause();} if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    close.addEventListener('click', shut);
    dlg.addEventListener('click', function(e){ if (e.target === dlg) shut(); });
    dlg.addEventListener('cancel', function(){ var v=vid(); if(v) v.pause(); });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
